/**
 * @author Ivan Toth.
 * tables inside of the duplicate check
 */
var dcItemBindings = { item: '=', row: '<', comp: '<', filter: '=' };
var MultiDcController = (function () {
    function MultiDcController($scope, socket, settings, topic, Dialog, $state, $timeout, env, $http, notify) {
        var _this = this;
        this.$scope = $scope;
        this.socket = socket;
        this.settings = settings;
        this.topic = topic;
        this.Dialog = Dialog;
        this.$state = $state;
        this.$timeout = $timeout;
        this.env = env;
        this.$http = $http;
        this.notify = notify;
        this.tableStyle = { 'padding': '0px', 'border': 'none' };
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.expand = false;
        // receive broadcasts in case some1 wants to expand or collapse sections
        this.socket.forward('expand.all', this.$scope);
        this.$scope.$on('expand.all.' + this.comp, function (event, data) {
            _this.toggle(data);
        });
        this.filterObject = {};
        this.searchCriteria = false;
        this.showSecondary = false;
        this.columnNamesKey = this.topic.checksData.uiVersion > this.OPP_VERSION_4 && this.comp === 'dc'
            ? 'dc_v5'
            : this.comp;
        // console.log('this.columnNamesKey...');
        // console.log(this.columnNamesKey);
    }
    MultiDcController.prototype.$onInit = function () {
        var _this = this;
        //Fill the reports object
        if (angular.isDefined(this.item)) {
            this.filterObject = {
                notEmpty: false,
                calculated: false,
                filters: {}
            };
            // Prepare filter object
            if (this.item.table) {
                this.item_array = angular.copy(this.item.table);
            }
            else if (Array.isArray(this.item) && this.item.length > 0) {
                this.item_array = angular.copy(this.item[0].table);
            }
            else if (this.item && Array.isArray(this.item.results) && this.item.results.length > 0) {
                this.item_array = angular.copy(this.item.results[0].table);
            }
            if (this.item.table && this.item.table.length > 0) {
                this.filterObject.notEmpty = true;
                angular.forEach(this.item.table, function (arr) {
                    for (var prop in arr) {
                        _this.filterObject.filters[prop] = { unique: [], picked: [], type: 's', cond: '=' };
                    }
                    ;
                });
                this.makeFilterOptions();
                this.filterObject.calculated = false;
            }
        }
        var tempArray = [];
        this.rowOrder = [];
        this.dropRowOrder = [];
        var mainCols = [];
        var secondCols = [];
        //Create columns for the table
        if (angular.isDefined(this.item) && angular.isDefined(this.item.colVer)) {
            angular.forEach(this.settings.allColumnOrder, function (columnOrder) {
                angular.forEach(columnOrder.ds, function (ds) {
                    if (ds === _this.item.ds) {
                        mainCols = columnOrder[_this.item.colVer].main;
                        secondCols = columnOrder[_this.item.colVer].second;
                    }
                });
            });
            angular.forEach(mainCols, function (columns) {
                tempArray.push(columns);
                _this.columnObj = (_this.columnNamesKey && angular.isDefined(_this.settings.columnNames[_this.columnNamesKey][columns])) ? _this.settings.columnNames[_this.columnNamesKey][columns] : { h: columns };
                _this.columnObj.v = columns;
                if (_this.columnObj.t && _this.columnObj.t.indexOf('collapse') > -1) {
                    _this.dropRowOrder.push(_this.columnObj);
                    _this.showSecondary = true;
                }
                else {
                    _this.rowOrder.push(_this.columnObj);
                }
            });
            angular.forEach(secondCols, function (columns) {
                _this.columnObj = (_this.columnNamesKey && angular.isDefined(_this.settings.columnNames[_this.columnNamesKey][columns])) ? _this.settings.columnNames[_this.columnNamesKey][columns] : { h: columns };
                _this.columnObj.v = columns;
                _this.dropRowOrder.push(_this.columnObj);
            });
            if (this.dropRowOrder.length > 0) {
                this.showSecondary = true;
            }
        }
        // Create columns for the columns, that are not listed in  cloudant
        if (this.item && this.item.table && this.item.table.length > 0) {
            for (var prop in this.item.table[0]) {
                var found = true;
                var cmrMigratedPropsToExclude = ['type', 'searchCriteria_id', '_id', '_rev', 'parent_doc_id', 'isMigrated'];
                if (mainCols.indexOf(prop) > -1 || secondCols.indexOf(prop) > -1 || prop === '$$hashKey' || prop === 'gov' || prop === 'unk' || prop === 'cmrDuns' || cmrMigratedPropsToExclude.includes(prop)) {
                    found = false;
                }
                if (found) {
                    tempArray.push(prop);
                    this.columnObj = (this.columnNamesKey && angular.isDefined(this.settings.columnNames[this.columnNamesKey][prop])) ? this.settings.columnNames[this.columnNamesKey][prop] : { h: prop };
                    this.columnObj.v = prop;
                    if (this.columnObj.t && this.columnObj.t.indexOf('collapse') > -1) {
                        this.dropRowOrder.push(this.columnObj);
                        this.showSecondary = true;
                    }
                    else {
                        this.rowOrder.push(this.columnObj);
                    }
                }
            }
            this.countDrop = [];
            for (var i = 0; i < this.rowOrder.length; i++) {
                this.countDrop[i] = 0;
            }
            this.filterArray = angular.copy(tempArray);
        }
    };
    // If variable name is know, than it sets the Description from cloudant, otherwise call the header as the variable name
    /**
      Toggle Searched criteria that was used to get this search
      @returns void
    */
    MultiDcController.prototype.toggleCriteria = function () {
        this.searchCriteria = (this.searchCriteria) ? false : true;
    };
    // /**
    //   Toggle Searched criteria that was used to get this search
    //   @returns void
    // */
    // getChecksCompare(item) {
    //   console.info(item);
    //   return 'sss'
    // }
    /**
      Clears the selected filter
      @param filtName     name of the filter
      @returns void
    */
    MultiDcController.prototype.clearFilter = function (filtName) {
        this.filterObject.filters[filtName].picked = [];
        this.blurFilterPick();
    };
    /**
      Expands or collapses sections
      @param value    boolean to decide if expand or collapse
      @returns void
    */
    MultiDcController.prototype.toggle = function (value) {
        if (angular.isUndefined(value)) {
            this.expand = this.expand ? false : true;
        }
        else {
            this.expand = value;
        }
    };
    /**
      Toggles the table row, when it contains a secondary row as a table
      @param rowObj    row to be toggled
      @returns void
    */
    MultiDcController.prototype.toggleRow = function (rowObj) {
        if (angular.isDefined(rowObj.visible) && rowObj.visible) {
            rowObj.visible = false;
        }
        else {
            rowObj.visible = true;
        }
    };
    /**
      Downloads any file from cloudant
      @returns void
    */
    MultiDcController.prototype.downloadAttachment = function () {
        console.log('sending export Excel request');
        var name = 'DMT-' + this.item.ds + this.item.timestamp + '.xlsx'; ////CHECKTHIS - is item.ds opp or stateParam.id
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadAttachment',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.topic._id,
                    name: name
                }
            }
        });
    };
    /**
      Export report into Excel file
      @returns void
    */
    MultiDcController.prototype.excelExport = function () {
        console.log('sending export Excel request');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.getId(this.topic.topic._id),
                    comp: this.columnNamesKey,
                    timestamp: this.item.timestamp,
                    arrayResults: this.item.table
                }
            }
        });
    };
    /**
      Clicked / selected a item in the filter select, this will ensure, that the table will be recalculated when dropdown closes
      @returns void
    */
    MultiDcController.prototype.changedValue = function () {
        this.filterObject.calculated = false;
    };
    /**
     Will create unique items for the filters in the table
     @returns void
    */
    MultiDcController.prototype.makeFilterOptions = function () {
        var _this = this;
        //if (this.filterObject.notEmpty) {
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            //browse through every item in table
            this.filterObject.calculated = true;
            angular.forEach(this.item_array, function (tableLine) {
                //if the item is unique, put it into the representing unique value
                for (var prop in _this.filterObject.filters) {
                    if (_this.filterObject.filters[prop].type === 's') {
                        if (_this.filterObject.filters[prop].unique.indexOf(tableLine[prop]) < 0) {
                            _this.filterObject.filters[prop].unique.push(tableLine[prop]);
                        }
                    }
                }
            });
        }
    };
    /**
     Opens the dropdown with the filters. By changing this, we'll change the limitTo of the filter ng-repeat. This is done for
     performance increase(So DOM doenst have to have in special cases 4k+ checkboxes)
     @param id        id of the filter
     @param size      size of the filter
     @returns void
    */
    MultiDcController.prototype.openDrop = function (id, size) {
        this.countDrop[id] = size;
    };
    /**
     Closes dropdown and sets the limitTo on the filter to 0
     @param id        id of the filter
     @returns void
    */
    MultiDcController.prototype.closeDrop = function (id) {
        this.countDrop[id] = 0;
        this.blurFilterPick();
    };
    /**
     Based on the filters selected, only those lines in table are picked, that fullfill the picked filter values
     @returns void
    */
    MultiDcController.prototype.blurFilterPick = function () {
        var _this = this;
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            //if (this.filterObject.notEmpty) {
            var tempArray_1 = [];
            var filterOK_1 = true;
            angular.forEach(this.item.table, function (tableLine) {
                filterOK_1 = true;
                var _loop_1 = function(prop) {
                    if (_this.filterObject.filters[prop].type === 's' && filterOK_1) {
                        if (_this.filterObject.filters[prop].picked.length > 0) {
                            filterOK_1 = false;
                            angular.forEach(_this.filterObject.filters[prop].picked, function (picked) {
                                if (picked === tableLine[prop]) {
                                    filterOK_1 = true;
                                }
                            });
                        }
                    }
                };
                for (var prop in _this.filterObject.filters) {
                    _loop_1(prop);
                }
                if (filterOK_1) {
                    tempArray_1.push(tableLine);
                }
            });
            this.item_array = angular.copy(tempArray_1);
        }
    };
    /**
     Removes the data in the report. (Excel report to be removed still needs to be applied)
     @returns void
    */
    MultiDcController.prototype.removeReport = function (event, comp, row) {
        var _this = this;
        var items = { message: 'Click OK to delete the results ot this search', okMessage: 'Remove', cancelMessage: 'Cancel' };
        this.Dialog.updateValidForm(event, items, 'ok-cancel.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                var upData = { id: _this.topic.topic._id, data: {}, type: [comp, 'comments$' + _this.topic.tabs.short] };
                var data = {};
                _this.topic.setTempFromTopicPart(comp);
                // clears the table object
                data[comp + '.results.' + row + '.table'] = { clearArray: true, data: [] };
                data[comp + '.results.' + row + '.deleted'] = { add: true, data: true };
                upData['data'] = data;
                _this.topic.setTempFromTopicPart('comments$' + _this.topic.tabs.short);
                var commentObj = {};
                commentObj = {
                    time: (new Date()).getTime(),
                    source: _this.topic.topic.owner,
                    comment: comp + ' search result ' + row + ' cleared'
                };
                _this.topic.temp.comments[_this.$state.current.name.replace('detail.', '')].push(commentObj);
                // sets the comment to be added into topic on server
                data['comments.' + _this.$state.current.name.replace('detail.', '')] = { push: true, data: [commentObj] };
                _this.topic.temp[comp].results[row].table = [];
                _this.topic.temp[comp].results[row].deleted = true;
                _this.topic.updateServerTopic('couchUpdate', upData, false);
            }
            return;
        });
    };
    MultiDcController.prototype.showCmrArrayList = function () {
        var toggleDecision = this.expand ? false : true;
        this.toggle(toggleDecision);
        var cmrString = this.item.searchCriteria[0].v || '';
        var items = {
            dialogName: cmrString.split(', ')
        };
        this.Dialog.updateValidForm(event, items, 'cmrArray-dialog.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
    };
    MultiDcController.$inject = ['$scope', 'socket', 'settings', 'topic', 'Dialog', '$state', '$timeout', 'env', '$http', 'notify'];
    return MultiDcController;
}());
var MultiDcComponent = (function () {
    function MultiDcComponent() {
        this.bindings = dcItemBindings;
        this.templateUrl = 'detail-table-dc-multi.html';
        this.controller = MultiDcController;
    }
    return MultiDcComponent;
}());
angular
    .module('application')
    .component('multiDcTable', new MultiDcComponent());

//# sourceMappingURL=detail.table.multidc.component.js.map
